// Core
import React, { Component } from 'react'
import { connect } from 'react-redux'
import MacroLink from '../MacroLink'
import { deletedVariablesCleared, changesMade } from '../../actions/actions'
import css from './styles.scss'
import globalCss from '../../../scss/global.scss'
import { generateVariableKey } from '../../utils'

export class MacroEnabledContent extends Component {
  constructor ({ styles, isOption, multiLine, editorClassName, templateString, app: { secondaryColor } }) {
    super()
    this.draggedEle = null
    this.timeout = null
    this.templateString = templateString
    this.tagName = 'p'
    this.editorProps = {
      style: { borderLeftColor: secondaryColor },
      className: `${editorClassName} ${css.genericEditor}`,
      contentEditable: true,
      suppressContentEditableWarning: true,
      onDrop: this.dropped,
      id: 'ced',
      onInput: this.editableAreaChanged,
      ref: ele => {
        this.contentArea = ele
      },
      onBlur: isOption ? this.reportOptionContents : null
    }
    if (!multiLine) {
      this.editorProps.style = { ...this.editorProps.style, maxHeight: 38, overflow: 'hidden' }
    }

    this.state = {
      refresh: 0,
      editableContent: null,
      contextMenuOptions: null
    }

    this.firefox = navigator.userAgent.toLowerCase().indexOf('firefox') > -1
  }

  dropped = evt => {
    if (!evt.altKey && !this.copyEle) {
      try {
        this.draggedEle.remove()
      } catch (err) {

      }
    }
    setTimeout(() => {
      this.populateInput()
      this.props.dispatch(changesMade())
    }, 0)
  }

  populateInput = () => {
    const contentAsString = this.stringFromUntrackedMarkup()
    const dividedTemplateString = this.divideTemplateString(contentAsString)
    const components = this.componentsFromDividedTemplateString(dividedTemplateString)
    // const components = this.componentsFromUntrackedMarkup()
    const wrapped = (
      <div {...this.editorProps} key={contentAsString}>
        {components}
      </div>
    )
    this.setState({
      editableContent: null
    }, () => {
      this.setState({
        editableContent: wrapped
      }, () => {
        this.contentArea.focus()
      })
    })
  }

  startDrag = evt => {
    this.draggedEle = evt.target
    this.copyEle = false
  }

  startCopyDrag = evt => {
    this.draggedEle = evt.target
    this.copyEle = true
  }

  extractedContents (child) {
    let isP
    const [node] = child.childNodes
    if (node) {
      if (child.tagName === 'P' && node.nodeType === 3) {
        isP = true
      }
    }
    if (child.childNodes.length > 0 && child.tagName !== 'A' && !isP) {
      let kidContent = ''
      if (child.tagName === 'DIV') {
        kidContent += '\n'
      }
      for (let i = 0, numKids = child.childNodes.length; i < numKids; i++) {
        let contents = ''
        const kid = child.childNodes[i]
        if (kid.nodeType === 3) {
          contents += kid.textContent
        } else if (kid.nodeType === 1) {
          contents = this.extractedContents(kid)
        }
        kidContent += contents
      }
      return kidContent
    } else {
      if (child.tagName === 'A') {
        const dataAttrs = child.dataset
        const { parentElement: { tagName, childNodes } } = child
        let { variableName, instance } = dataAttrs
        let addNewLine = ''
        if (!instance) {
          instance = generateVariableKey()
        }
        if (tagName === 'P' && childNodes[childNodes.length - 1] === child) {
          addNewLine = '\n'
        }
        return '${ ' + variableName + '_' + instance + ' }' + addNewLine
      } else if (child.tagName === this.tagName.toUpperCase()) {
        if (child.innerText) return child.innerText + '\n'
        return '\n'
      } else {
        return child.innerText ? child.innerText : child.textContent
      }
    }
  }

  stripNewLines (string) {
    // https://stackoverflow.com/questions/784539/how-do-i-replace-all-line-breaks-in-a-string-with-br-tags
    // credit where credit is due
    return string.replace(/(?:\r\n|\r|\n)/g, ' ')
  }

  stringFromUntrackedMarkup (stripNewLines) {
    // TODO: DO THIS BETTER!
    let inputValue = ''
    const children = this.contentArea.childNodes

    // console.group()
    for (let i = 0, numNodes = children.length; i < numNodes; i++) {
      const child = children[i]
      const nextChild = children[i + 1]
      if (child.nodeType !== 3 && nextChild && nextChild.nodeType !== 3) {
        if (child.hasAttribute('data-spacer') && nextChild.hasAttribute('data-bars')) {
          continue
        }
      } else if (child.nodeType !== 3 && child.hasAttribute('data-bars')) {
        continue
      }
      const extracted = this.extractedContents(child)
      let nextExtracted
      if (i < numNodes - 1) {
        nextExtracted = this.extractedContents(children[i + 1])
      }
      if (extracted === String.fromCharCode(160) && (nextExtracted === '\n' || i === numNodes - 1)) {
        continue
      }
      inputValue += extracted
    }
    // console.groupEnd()
    if (stripNewLines) {
      inputValue = this.stripNewLines(inputValue)
    }
    return inputValue
  }

  divideTemplateString (string) {
    const str = string || ''
    const chunks = []
    let chunk = ''
    let inTemplateString = false
    for (let i = 0, len = str.length; i < len; i++) {
      const char = str[i]
      const next = str[i + 1]
      if (inTemplateString && char === '}') {
        chunk += char
        chunks.push(chunk)
        chunk = ''
        inTemplateString = false
      } else if (!inTemplateString && char === '$' && next === '{') {
        if (chunk.length > 0) {
          chunks.push(chunk)
        }
        inTemplateString = true
        chunk = char
      } else if (!inTemplateString && char === '\n') {
        if (chunk.length > 0) {
          chunks.push(chunk)
          chunk = ''
        }
        chunks.push('\n')
      } else {
        chunk += char
      }
    }
    if (chunk.length > 0) {
      chunks.push(chunk)
    }
    return chunks
  }

  componentsFromDividedTemplateString (dividedTemplateString) {
    const variables = this.props.item.variables
    const components = []
    for (let i = 0, numStr = dividedTemplateString.length; i < numStr; i++) {
      const chunk = dividedTemplateString[i]
      if (chunk.indexOf('${') === 0) {
        let content = chunk.substr(2, chunk.length - 3).trim()
        if (content.indexOf('_') === -1) {
          content += `_${generateVariableKey()}`
        }

        let splitSymbol = '_'
        let endSymbol = ''
        if (content.indexOf('_') === 0 && content.indexOf('__' !== -1)) {
          splitSymbol = '__'
          endSymbol = '_'
        }

        let [variable, key] = content.split(splitSymbol)

        if (endSymbol && endSymbol.length) {
          variable = variable + endSymbol
        }

        const varDeets = variables[variable]
        const macroProps = {
          varName: variable,
          key: `${i}_chunk`,
          index: i,
          dragStart: this.startDrag,
          readableName: 'hahahahahaah'
        }
        if (varDeets) {
          components.push(<MacroLink {...macroProps} changesMade={changesMade} instanceKey={key} type={varDeets.macro} modal={this.props.modal} key={`${i}_chunk`} />)
          if (dividedTemplateString[i + 1] === '\n' || !dividedTemplateString[i + 1]) {
            // adds a space after a variable if it's the last one on a line
            // the rich editor really borks it on line endings
            components.push(<span key={`${i}_spacechunk`}>&nbsp;</span>)
          }
        }
      } else if (chunk === '\n') {
        // components.push(<div key={ `${ i }_chunk` }><br/></div>) <-- BAD >:(
        if (i > 0 && dividedTemplateString[i - 1] === '\n') {
          components.push(<this.tagName key={`${i}_chunk`} className={css.contentSpacer} data-spacer />)
        } else {
          components.push(<this.tagName key={`${i}_chunk`} className={css.contentDivider} />)
        }
      } else {
        components.push(<span key={`${i}_chunk`}>{chunk}</span>)
      }
    }
    return components
  }

  componentDidMount () {
    const dividedTemplateString = this.divideTemplateString(this.props.templateString)
    const components = this.componentsFromDividedTemplateString(dividedTemplateString)
    const wrapped = (
      <div {...this.editorProps}>
        {components}
      </div>
    )
    this.setState({
      editableContent: wrapped
    })
    window.addEventListener('click', this.hideMenu)
    window.oncontextmenu = evt => {
      if (evt.target.getAttribute('id') !== 'ced') {
        this.hideMenu(null, true)
      }
    }
  }

  componentWillUnmount () {
    window.removeEventListener('click', this.hideMenu)
  }

  componentWillReceiveProps (nextProps) {
    if ((nextProps.templateString !== this.props.templateString) && !this.props.isOption) {
      this.populateInput()
    }
    if (nextProps.report === true && this.props.report === false) {
      this.props.save(this.stringFromUntrackedMarkup(!this.props.multiLine))
      clearTimeout(this.timeout)
    }
    if (nextProps.variables.clearDeletedVariables === true && this.props.variables.clearDeletedVariables === false) {
      setTimeout(() => {
        const dividedTemplateString = this.divideTemplateString(nextProps.templateString)
        const components = this.componentsFromDividedTemplateString(dividedTemplateString)
        // const components = this.componentsFromUntrackedMarkup()
        const wrapped = (
          <div {...this.editorProps}>
            {components}
          </div>
        )
        this.setState({
          editableContent: null
        }, () => {
          this.setState({
            editableContent: wrapped
          })
        })
        this.props.dispatch(deletedVariablesCleared())
      }, 0)
    }
  }

  handleSelection = (evt, pasteText = '') => {
    let text
    if (pasteText) {
      text = pasteText
    } else {
      text = '${ ' + evt.target.getAttribute('data-original') + ' }'
    }
    const selection = window.getSelection()
    const range = selection.getRangeAt(0)
    range.insertNode(document.createTextNode(text))
    this.populateInput()
    this.props.dispatch(changesMade())
  }

  handleMenu = evt => {
    evt.stopPropagation()
    evt.preventDefault()
    this.askPermission()
    this.hideMenu(null, true)
    const menu = evt.currentTarget.children[0]
    const rect = evt.currentTarget.getBoundingClientRect()
    menu.style.display = 'block'
    menu.style.top = (evt.clientY - rect.top) + 'px'
    menu.style.left = (evt.clientX - rect.left) + 'px'
  }

  hideMenu = (evt, toggle = false) => {
    if (toggle || evt.button === 0) {
      document.querySelectorAll('[data-varList]').forEach(menu => {
        menu.style.display = 'none'
      })
    }
  }

  handleCopy = () => {
    document.execCommand('copy')
  }

  handleCut = () => {
    document.execCommand('cut')
    this.props.dispatch(changesMade())
  }

  handlePaste = () => {
    navigator.clipboard.readText()
      .then(text => {
        this.handleSelection(null, text)
        this.props.dispatch(changesMade())
      })
      .catch(() => {})
  }

  askPermission = () => {
    navigator.permissions.query({ name: 'clipboard-read' })
      .then(result => {
        if (result.state === 'granted' || result.state === 'prompt') {
          this.contextOptions(true)
        } else {
          this.contextOptions(false)
        }
      })
      .catch(() => {
        this.contextOptions(false)
      })
  }

  contextOptions = pasteCommand => {
    let listItems
    if (pasteCommand) {
      listItems = (
        <ul>
          <li onClick={this.handlePaste}><i className={globalCss.iconPaste} />Paste as Plain Text</li>
          <li className={css.noHighlight}><i className={globalCss.iconPaste} />Paste with Variables ({this.getShortcut()})</li>
        </ul>
      )
    } else {
      listItems = (
        <li className={css.noHighlight}><i className={globalCss.iconPaste} />Paste ({this.getShortcut()})</li>
      )
    }
    this.setState({
      contextMenuOptions: listItems
    })
  }

  getShortcut = () => {
    if (window.navigator.userAgent.indexOf('Mac') !== -1) {
      return '⌘ + V'
    } else {
      return 'CTRL + V'
    }
  }

  handleKeyUp = evt => {
    clearTimeout(this.timeout)
    this.timeout = setTimeout(() => {
      this.props.dispatch(changesMade())
    }, 2000)
  }

  reportOptionContents = evt => {
    const updatedString = this.stringFromUntrackedMarkup(evt.target.innerText)
    this.props.updateTemplateString(updatedString)
  }

  render () {
    const { editableContent, contextMenuOptions } = this.state
    let { item: { variableOrder, varNameMap, variables } } = this.props
    variableOrder = variableOrder || []
    const listItems = variableOrder.map((varName, index) => {
      if (variables[varName].macro !== 'choiceFromDataSource') {
        return <li key={`${index}_listItem`} data-original={varName}><i className={globalCss.iconEditCircle} />{varNameMap[varName]}</li>
      } else {
        return null
      }
    })
    const list = (
      <div className={css.variableWrapper} data-varlist>
        <ul className={listItems.length ? css.commandUnderline : css.commandNoUnderline}>
          <li onClick={this.handleCopy}><i className={globalCss.iconCopy} />Copy</li>
          <li onClick={this.handleCut}><i className={globalCss.iconScissors} />Cut</li>
          {contextMenuOptions}
        </ul>
        <ul onClick={this.handleSelection}>
          {listItems}
        </ul>
      </div>
    )

    return (
      <div onContextMenu={this.handleMenu} className={css.editableWrapper} onKeyUp={this.handleKeyUp}>
        {list}
        {editableContent}
      </div>
    )
  }
}

const mapStateToProps = state => {
  const { app, item, variables } = state
  return {
    app,
    item,
    variables
  }
}

export default connect(mapStateToProps)(MacroEnabledContent)



// WEBPACK FOOTER //
// /app/js/components/MacroEnabledContent/index.js